import { createBasicSelector } from 'util/redux'
import { selectRequestByType } from 'ducks/requests/selectors'
import { selectAccountId } from 'ducks/accounts/selectors/selectAccountId'
import { buildFetchFolderCountsRequestKey } from '../utils/request'

export const selectFetchFolderCountsRequestForChannelId = createBasicSelector(
  (state, channelId) =>
    selectRequestByType(
      state,
      buildFetchFolderCountsRequestKey(channelId, selectAccountId(state))
    )
)
